module.exports = __webpack_public_path__ + "static/media/28.c8844d6b.jpg";